import i18next, { t } from 'i18next';
import React from 'react';
import PropTypes from 'prop-types';
import ReactApexChart from 'react-apexcharts';
import { Card, Col, Row } from 'react-bootstrap';

class ELEMENT_CONTRACT_SERVICE_SUMMARY extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      series: [
        {
          name: t('data-lang-lbl-spent'),
          data: !this.props.inputParam_UseFake ? (this.props.inputParam_ComponentContent !== null && this.props.inputParam_ComponentContent.items !== null ? this.props.inputParam_ComponentContent.items.map(x => x.epMesMontoPago) : []): [33, 33, 33],
          color: "#406A9C"
        },
        {
          name: t('data-lang-lbl-available'),
          data: !this.props.inputParam_UseFake ? (this.props.inputParam_ComponentContent !== null && this.props.inputParam_ComponentContent.items !== null ? this.props.inputParam_ComponentContent.items.map(x => x.epMesSaldo) : []): [33, 33, 33],
          color: "#84B681"
        }
      ],
      options: {
        chart: {
          type: 'bar',
          stacked: true,
          stackType: '100%'
        },
        plotOptions: {
          bar: {
            horizontal: true
          }
        },
        legend: {
          show: true,
          position: 'top',
        },
        xaxis: {
          categories: !this.props.inputParam_UseFake ? (this.props.inputParam_ComponentContent !== null && this.props.inputParam_ComponentContent.items !== null ? this.props.inputParam_ComponentContent.items.map(x => `${x.nombrePartida} ${x.unidadPartida?'('+x.unidadPartida+')':''}`) : []): [t('data-lang-lbl-partyname')  + " 1", t('data-lang-lbl-partyname')  + " 2", t('data-lang-lbl-partyname')  + " 3"],
        },
        tooltip: {
          theme: 'dark',
          x: {
            show: false
          },
          y: {
            formatter: function(value, { series, seriesIndex, dataPointIndex, w }) {
              return value !== null ? parseFloat(value.toFixed(2)).toLocaleString(i18next.language) : value;
            }
          },
        },
      }
    };
  }

  static propTypes = {
    inputParam_HideHeader: PropTypes.bool,
    inputParam_UseFake: PropTypes.bool,
  };

  static defaultProps = {
    inputParam_HideHeader: false,
    inputParam_UseFake: false,
  };

  renderContent() {
    const aux_data = !this.props.inputParam_UseFake ? (this.props.inputParam_ComponentContent !== null && this.props.inputParam_ComponentContent.items !== null ? this.props.inputParam_ComponentContent.items.map(x => x.epMesSaldo) : []): [33, 33, 33];

    return  <Row className={`px-3 ${aux_data.length > 10 ? '' : 'h-100' } `} style={aux_data.length > 10 ? {height: ((aux_data.length/10) * 100) + '%', opacity: this.props.inputParam_UseFake ? ".4" : ""} : { opacity: this.props.inputParam_UseFake ? ".4" : ""}}>
              <Col>
                <ReactApexChart options={this.state.options} series={this.state.series} type="bar" height="100%" />
              </Col>
            </Row>
  }

  render() {
    return (
      <>
        {
          !this.props.inputParam_UseFake &&
          <Card className='h-100'>
            {
              !this.props.inputParam_HideHeader &&
              <Card.Header className="card-header-compact">
                <Card.Title className="d-flex justify-content-between">
                  <b>{ this.props.inputParam_ComponentContent !== null && this.props.inputParam_ComponentContent.boardComponentTitle !== null ? this.props.inputParam_ComponentContent.boardComponentTitle : t('data-lang-boxname-distributionchart')}</b>
                  <div className='toolbar d-flex'>
                  </div>
                </Card.Title>
              </Card.Header>
            }
            <Card.Body className='px-1 h-100' style={{ overflowY: "scroll", overflowX: "hidden"}}>
              {
                this.renderContent()
              }
            </Card.Body>
          </Card>
        }
        {this.props.inputParam_UseFake && this.renderContent()}
      </>
    );
  }
}

export default ELEMENT_CONTRACT_SERVICE_SUMMARY;